import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import Box from 'components/Box';
import BulletList from 'components/BulletList';
import Button from 'components/Button';
import CenterContent from 'components/CenterContent';
import CollectionGrid, { CollectionGridItem } from 'components/CollectionGrid';
import DashedBox from 'components/DashedBox';
import Icon from 'components/Icon';
import InlineList from 'components/InlineList';
import PageTitle from 'components/PageTitle';
import ShadedCard from 'components/ShadedCard';
import Stack from 'components/Stack';
import Text from 'components/Text';
import { commonThumbnailOptions, handleRejectFiles } from 'components/ThumbnailUploader/utils';
import { MainThumbnailPreviewModalWrapper } from '.';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function ArtworkGuideline(_ref) {
  var guideTitle = _ref.guideTitle,
    recommendations = _ref.recommendations;
  return /*#__PURE__*/_jsxs(ShadedCard, {
    px: "m",
    py: "s",
    width: "100%",
    children: [/*#__PURE__*/_jsx(Text, {
      bold: true,
      as: "h2",
      mb: "xxs",
      children: guideTitle
    }), /*#__PURE__*/_jsx(BulletList, {
      children: recommendations.map(function (recommendation) {
        return recommendation;
      })
    })]
  });
}
export function ActionWrapper(_ref2) {
  var id = _ref2.id,
    previewUrl = _ref2.previewUrl,
    _ref2$isDisabled = _ref2.isDisabled,
    isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
    guideTitle = _ref2.guideTitle,
    recommendations = _ref2.recommendations,
    children = _ref2.children,
    onClose = _ref2.onClose,
    onCancel = _ref2.onCancel,
    onConfirm = _ref2.onConfirm,
    onReplace = _ref2.onReplace;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isNewImage = !!previewUrl;
  var rejectFile = useCallback(function (rejectedFiles) {
    handleRejectFiles(rejectedFiles);
  }, []);
  var acceptFile = useCallback(function (acceptedFiles) {
    onReplace({
      file: acceptedFiles[0]
    });
  }, [onReplace]);
  var _useDropzone = useDropzone(_objectSpread(_objectSpread({}, commonThumbnailOptions), {}, {
      onDropAccepted: acceptFile,
      onDropRejected: rejectFile,
      disabled: isDisabled,
      // Disable click and keydown behavior
      noClick: true,
      noKeyboard: true
    })),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    open = _useDropzone.open;
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, getRootProps({
    className: 'dropzone'
  })), {}, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsxs(MainThumbnailPreviewModalWrapper, {
      id: id,
      onClose: onClose,
      buttonText: isNewImage ? t('actions_cancel') : undefined,
      pageSections: children,
      children: [/*#__PURE__*/_jsx(PageTitle, {
        size: "large",
        mb: "l",
        children: t('actions_review_cover_image')
      }), /*#__PURE__*/_jsxs(CollectionGrid, {
        children: [/*#__PURE__*/_jsx(CollectionGridItem, {
          large: true,
          children: /*#__PURE__*/_jsx(ArtworkGuideline, {
            guideTitle: guideTitle,
            recommendations: recommendations
          })
        }), !isDisabled && /*#__PURE__*/_jsx(CollectionGridItem, {
          large: true,
          children: /*#__PURE__*/_jsx(DashedBox, {
            width: "100%",
            height: "100%"
            // Only allow clicking whole area to upload when
            // there's not currently an image being previewed
            // (in that case we're showing dedicated buttons)
            ,
            onClick: isNewImage ? undefined : open,
            cursor: isNewImage ? 'default' : 'pointer',
            children: /*#__PURE__*/_jsx(CenterContent, {
              height: "100%",
              children: /*#__PURE__*/_jsx(Box, {
                bold: true,
                textAlign: "center",
                p: "m",
                children: isNewImage ? /*#__PURE__*/_jsxs(Stack, {
                  spacing: "s",
                  children: [/*#__PURE__*/_jsx(Box, {
                    as: "img",
                    alt: "",
                    src: previewUrl,
                    maxWidth: 200,
                    maxHeight: 70,
                    style: {
                      objectFit: 'scale-down'
                    },
                    boxShadow: "soft"
                  }), /*#__PURE__*/_jsxs(InlineList, {
                    spacing: "xs",
                    children: [/*#__PURE__*/_jsx(Button, {
                      variant: "primary",
                      onClick: onConfirm,
                      isDisabled: isDisabled,
                      children: t('actions_confirm')
                    }), /*#__PURE__*/_jsx(Button, {
                      onClick: open,
                      isDisabled: isDisabled,
                      children: t('actions_upload_new_image')
                    }), /*#__PURE__*/_jsx(Button, {
                      onClick: onCancel,
                      isDisabled: isDisabled,
                      children: t('actions_cancel')
                    })]
                  })]
                }) : /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Icon, {
                    dimmed: true,
                    name: "drag-and-drop",
                    scale: 2.5,
                    mb: "xs"
                  }), /*#__PURE__*/_jsx("br", {}), t('actions_click_or_drag_to_replace_image')]
                })
              })
            })
          })
        })]
      })]
    })]
  }));
}
export default ActionWrapper;